import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { getSession } from '@/lib/auth-client'
import { safeAuthRedirect } from '@/lib/auth-redirect'

export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ location }) => {
    // An emailed reset link must also work when this browser has a session.
    if (location.pathname === '/reset-password') return
    let authenticated = false
    try {
      const session = await getSession()
      authenticated = !!session?.data?.user
    } catch { /* Let the sign-in page report connection errors. */ }
    if (authenticated) throw redirect({ href: safeAuthRedirect(new URLSearchParams(location.searchStr).get('redirect')), reloadDocument: true })
  },
  component: AuthLayout,
})

function AuthLayout() {
  return (
    <div className="min-h-screen w-full">
      <Outlet />
    </div>
  )
}
